import { useLocation } from "react-router-dom";
import { matchPath } from "react-router-dom";
import { breadcrumbRoutes } from "../utils/breadcrumbConfig";

/**
 * Retourne la chaîne de breadcrumbs correspondant à l'URL courante.
 * Essaie d'abord une correspondance exacte, puis les patterns dynamiques (:param).
 * Retourne [{ label: "Accueil", path: "/" }] si aucune correspondance.
 */
export const useBreadcrumb = () => {
  const location = useLocation();
  const pathname = location.pathname;

  // 1. Correspondance exacte (plus rapide, couvre la majorité des routes)
  const exact = breadcrumbRoutes.find((r) => r.pattern === pathname);
  if (exact) return exact.crumbs;

  // 2. Correspondance par pattern dynamique (:param)
  for (const route of breadcrumbRoutes) {
    if (!route.pattern.includes(":")) continue;
    const match = matchPath({ path: route.pattern, end: true }, pathname);
    if (match) return route.crumbs;
  }

  // 3. Fallback : Accueil uniquement (pas de breadcrumb affiché)
  return [{ label: "Accueil", path: "/" }];
};
